import React from 'react'
import Research from '../../components/research/Research'

const index = () => {
  return (
    <div>
       <Research />
    </div>
  )
}

export default index